module.exports = __webpack_public_path__ + "df6a9ffba8079487168ecc87f8edd1ab.pdf";